export default "__VITE_ASSET__BiHyJk2b__"